module.exports = __webpack_public_path__ + "img/202306_01_sp.3b8998fd.jpg";